import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccordionCoordinatorService {


  private opened$ = new ReplaySubject<string>(1);
  constructor() { }

  announceOpen(title: string) {this.opened$.next(title)};

  onOpened(): Observable<string> {
    return this.opened$.asObservable();
  }
}
